import React, { useState } from 'react';
import styled from 'styled-components';
import { ConfigFieldControl } from '@sierralabs/core-ui';
import SiteDialogPicker from '../../common/pickers/SiteDialogPicker';
import { useSiteDialogComponents } from '../../hooks/site-dialog/useSiteDialogComponents';
import { useSiteContext } from '../../SiteContext';
const StyledDiv = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const SiteEventDialogConfigurator = props => {
    const { onChange } = props;
    const [config, setConfig] = useState(props.config || {});
    return (React.createElement(StyledDiv, { className: 'event-dialog-configurator' },
        React.createElement(ConfigFieldControl, null,
            React.createElement(SiteDialogPicker, { variant: 'outlined', value: config === null || config === void 0 ? void 0 : config.dialogId, onChange: dialog => {
                    const newConfig = Object.assign(Object.assign({}, config), { dialogId: dialog === null || dialog === void 0 ? void 0 : dialog.id });
                    setConfig(newConfig);
                    onChange === null || onChange === void 0 ? void 0 : onChange(newConfig);
                } }))));
};
export const SiteEventDialogPlugin = {
    name: 'Open Dialog',
    type: 'dialog-open',
    eventTypes: ['onClick'],
    configurator: SiteEventDialogConfigurator,
    getConfigSummary: event => {
        const ConfigSummary = () => {
            var _a;
            const dialogs = useSiteDialogComponents();
            const dialog = dialogs.find(d => { var _a; return d.id === ((_a = event === null || event === void 0 ? void 0 : event.config) === null || _a === void 0 ? void 0 : _a.dialogId); });
            const title = (_a = dialog === null || dialog === void 0 ? void 0 : dialog.props) === null || _a === void 0 ? void 0 : _a.title;
            return dialog ? (React.createElement(React.Fragment, null,
                "Open dialog \"",
                React.createElement("span", { title: title ? dialog.name : undefined }, title || dialog.name),
                "\"")) : (React.createElement(React.Fragment, null, "Dialog not found."));
        };
        return React.createElement(ConfigSummary, null);
    },
    handler: (config, context, data) => {
        const { dialogs, openDialog } = context.hook;
        const dialog = dialogs.find(d => d.id === config.dialogId);
        if (dialog) {
            openDialog(context.componentId, dialog, data);
        }
        else {
            console.warn('Dialog not found.');
        }
    },
    useHook: () => {
        const { plugins, siteComponents, siteComponentMap, openDialog } = useSiteContext();
        // use dialog component from siteComponentMap since it contains
        // the updated component props and events updated by replaceComponent()
        const dialogTypes = plugins
            .filter(p => { var _a; return (_a = p.categories) === null || _a === void 0 ? void 0 : _a.includes('dialog'); })
            .map(p => p.type);
        const dialogs = Object.values(siteComponentMap).filter(c => {
            return (dialogTypes.includes(c.type) &&
                siteComponents.some(component => component.id === c.id));
        });
        return { dialogs, openDialog };
    }
};
//# sourceMappingURL=SiteEventOpenDialogPlugin.js.map